import { get, post, del } from './API';

export default {
  fetchExperiences: async () => get('/experiences'),
  fetchExperiencesByGroup: async (groupId) => get('/experiences', { group_id: groupId }),
  fetchExperienceById: async (id) => get('/experiences', { id }),
  createExperience: async (experience) => post('/experiences', experience),
  updateExperience: async (experience) => post('/experiences', experience),
  deleteExperience: async (id) => del('/experiences', { id }),
  uploadExperienceImage: async (experienceId, imageData, contentType) => post('/experiences', {
    action: 'upload_image',
    experience_id: experienceId,
    image_data: imageData,
    content_type: contentType,
  }),
  removeExperienceImage: async (experienceId) => post('/experiences', {
    action: 'remove_image',
    experience_id: experienceId,
  }),
};
